/**
 * @generated SignedSource<<4da02b189ad764697b671c487ca4ec62>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type HelpLayoutHorizontalAlignment = "CENTER" | "LEFT" | "RIGHT" | "%future added value";
export type HelpLayoutVerticalAlignment = "BOTTOM" | "MIDDLE" | "TOP" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type alignmentSettingsContextHookFragment$data = {
  readonly alignment: {
    readonly __id: string;
    readonly horizontalAlignment: HelpLayoutHorizontalAlignment | null;
    readonly verticalAlignment: HelpLayoutVerticalAlignment | null;
  } | null;
  readonly " $fragmentType": "alignmentSettingsContextHookFragment";
};
export type alignmentSettingsContextHookFragment$key = {
  readonly " $data"?: alignmentSettingsContextHookFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"alignmentSettingsContextHookFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "alignmentSettingsContextHookFragment",
  "selections": [
    {
      "concreteType": "HelpLayoutAlignmentSettings",
      "kind": "LinkedField",
      "name": "alignment",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "horizontalAlignment"
        },
        {
          "kind": "ScalarField",
          "name": "verticalAlignment"
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "__id"
            }
          ]
        }
      ]
    }
  ],
  "type": "HelpLayoutVisualConfig"
};

(node as any).hash = "39c2c6605fdc2a08a29e64bca508f0ba";

export default node;
